import { EnrollmentStatus } from '../enums/enrollment-status.enum';
import { IEnrollmentSchedule } from './ienrollment-summary.interface';

export interface IInstructorDayAvailability {
	availableTimes: string[];
	instructorAvailabilityID: number;
	timezoneID?: number;
}

export interface IInstructorDayAvailabilityDict {
	[key: number]: IInstructorDayAvailability;
}

export interface IInstructorScheduleAvailability {
	instructorUserID: number;
	instructorIndex?: number;
	topRankedInstructorUserID?: number;
	availabilities: IInstructorDayAvailabilityDict;
}

export interface IEnrollmentDayAvailability {
	enrollmentAvailabilityID: number;
	availableTime: string;
	timezoneID?: number;
}

export interface IEnrollmentDayAvailabilityDict {
	[key: number]: Array<IEnrollmentDayAvailability>;
}

export interface IEnrollmentAvailability {
	enrollmentID: number;
	dayAvailabilities: IEnrollmentDayAvailabilityDict;
}

export interface IEnrollmentScheduleRequest {
	startDate: string;
	lessonFrequency: number;
	timezoneID: number;
	enrollmentAvailabilities: IEnrollmentSchedule[];
	enrollmentSchedule: IEnrollmentSchedule[];
	languageExperience: string | null;
	learningNeeds: string | null;
	requestedInstructor: string | null;
	currentEnrollmentStatus?: EnrollmentStatus | null;
}

type DayInfo = {
	value: number;
	dayIndex: number;
	shortName: string;
	longName: string;
};

export const DayOfWeek: { [key: number]: DayInfo } = {
	0: { value: 1, dayIndex: 0, shortName: 'SUN', longName: 'Sunday' },
	1: { value: 2, dayIndex: 1, shortName: 'MON', longName: 'Monday' },
	2: { value: 3, dayIndex: 2, shortName: 'TUE', longName: 'Tuesday' },
	3: { value: 4, dayIndex: 3, shortName: 'WED', longName: 'Wednesday' },
	4: { value: 5, dayIndex: 4, shortName: 'THU', longName: 'Thursday' },
	5: { value: 6, dayIndex: 5, shortName: 'FRI', longName: 'Friday' },
	6: { value: 7, dayIndex: 6, shortName: 'SAT', longName: 'Saturday' }
} as const;

export type DayOfWeek = typeof DayOfWeek;
